import React from 'react';


export const UHCProcessingReadMe: React.FC = () => {
  return (
    <div>
      <h3>UHC Processing - Standard Procedure</h3>
      <p>Usually by 8 am Central on Saturday, UHC processing is fully complete. Check the processing by 8 am Central following this procedure.</p>
      <ol>
        <li>Update the date {'{Link to come}'} to the most recent past Wednesday on Saturday morning, and run it once for each line of business (<code>EI</code>, <code>CS</code>, and <code>MR</code>).</li>
        <li>Generally, <code>TotalJobsThisWeek</code> should be very similar to the previous week’s, and the same goes for the <code>AvgSeconds</code>, which is a reflection of the average 1002 job runtime.</li>
        <li>
          If the last result row count is not equal to the current week’s total expected job count, there is likely more processing to be done (except if there’s a failure to update the
          DateFinished in the job table or the job processor clears out the DateFinished, which are both possible edge cases).
        </li>
        <img id="uhc-processing-readme-1" role="img" src={`${window.customUIBaseUrl}/images/weekendRunMonitoringReadme/uhc-processing-readme-1.png`} alt="UHC Processing Image 1" className="d-block my-2" />
        <li>Compare average run time between weeks and if you see a big shift in one direction or the other, you may have a problem on your hands, and will need to dive in deeper.</li>
        <li>Once the number of completed jobs comes out as expected, you are done!</li>
      </ol>
      <h4>If Jobs Are Not Completing</h4>
      <p>If things are not progressing along to the point of nearing completion by 7am Central time on Saturday, it’s time to investigate what may be going on.</p>
      <ol>
        <li>Run this script under this comment <code>-- JOBS YET TO RUN OR THAT HAVE FAILED</code> {'{Link to come}'}.</li>
        <li>
          If you see jobs that show no <code>DateFinished</code>, but the project run configuration status is 5 (succeeded), you can safely ignore those jobs,
          but note they will not count towards the <code>JobCount</code> for completed jobs in the screenshot above.
        </li>
        <li>
          If some jobs have fully failed (failed and are no longer running), you will either have to queue them back up individually, using
          <code>/v2.0/Projects/{'{projectId}'}/runconfigurations/{'{runConfigurationId}'}/resubmit/{'{jobId}'}?overrideJobQueueName=adequacy_uhc_112</code>, or you can queue up all failed and processing
          jobs for the run configuration if there are a lot, using <code>/v2.0/Projects/{'{projectId}'}/runconfigurations/{'{runConfigurationId}'}/resubmit?overrideJobQueueName=custom_urgent_large</code>
        </li>
        <ul>
          <li>
            Make sure you have a token from a UHC user for authentication. Can be <code>cloud.admin</code> or a Resource Admin user, if you are one.
          </li>
        </ul>
        <li>Another option is to set a project, forcibly, to <code>Failed</code> (6 on the <code>ProjectRunConfiguration.Status</code>), and resubmit the project through the UI.</li>
      </ol>
    </div>
  );
};